import React from 'react';

/**
 * The on/off switch that sits beside a call sheet section's own heading
 * (13 Sep 2026).
 *
 * It started life as a single "Include On This Call Sheet" row at the top of
 * the builder. Tom asked for it moved: "No need to put at the top. Just a
 * small switch next to the sections heading." He's right — the builder is a
 * long page, and a control at the top governing Kit two thirds of the way
 * down is a control you don't find while you're looking at Kit. Beside the
 * heading, the switch is wherever the question occurs to you.
 *
 * Deliberately not an iOS-style slider. On a dark typographic surface a dot
 * plus a word reads faster and at a smaller size, and it sits on the
 * baseline of a display heading without fighting it.
 *
 * Saves on click — see toggleSection in CallSheetBuilder.tsx.
 */
export function SectionSwitch({
  label,
  on,
  onToggle,
  saving
}: {
  /** The section's name, for the accessible label only — the heading beside
      this already shows it, so repeating it here would be noise. */
  label: string;
  on: boolean;
  onToggle: () => void;
  saving?: boolean;
}) {
  return <button type="button" onClick={onToggle} disabled={saving} aria-pressed={on} aria-label={`${label} — ${on ? 'on' : 'off'} this call sheet`} title={on ? `${label} is on the crew link, the client link and the PDF. Click to leave it off — nothing is deleted.` : `${label} is left off the crew link, the client link and the PDF. Click to put it back on.`} className={`label-sm inline-flex shrink-0 items-center gap-2 border px-3 py-1.5 transition-colors duration-150 ease-out disabled:opacity-50 ${on ? 'border-paper/50 text-paper/70 hover:border-paper hover:text-paper' : 'border-paper/20 text-paper/35 hover:border-paper/50 hover:text-paper/70'}`} data-id="element-795" data-mp="2abl08n48sjms">
      <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full transition-colors duration-150 ease-out ${on ? 'bg-paper' : 'bg-paper/25'}`} data-id="element-796" data-mp="3c17x6h5l1q61" />
      {on ? 'On' : 'Off'}
    </button>;
}